<template>
  <div>
    <div style="margin:10px 0;">
      截至目前：总用户 {{allCount.totalNewUserCount}}人，其中系统推广{{allCount.totalSystemPromotionCount}}人，他人推广{{allCount.totalOtherPromotionCount}}人，自主注册{{allCount.totalSelfRegisterCount}}人
    </div>
    <el-tabs v-model="activeName" @tab-click="handleClick">
      <el-tab-pane label="用户统计" name="0"></el-tab-pane>
      <el-tab-pane label="用户明细" name="1"></el-tab-pane>
    </el-tabs>
    <div v-if="activeName == 0">
      <!--顶部工具条-->
      <el-col :span="24">
        <el-form :inline="true">
          <el-form-item label="时间:">
            <el-date-picker
              v-model="filters.serachTimer"
              :unlink-panels="true"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="金额范围:">
            <el-input
              v-model="filters.startAmount"
              placeholder="请输入"
              style="width: 100px"
              clearable
            ></el-input
            >——
            <el-input
              v-model="filters.endAmount"
              placeholder="请输入"
              style="width: 100px"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <toolbar
              :buttonList="buttonList"
              @callFunction="callFunction"
            ></toolbar>
          </el-form-item>
        </el-form>
      </el-col>
      <!--列表-->
      <el-table
        :data="tableData"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%"
        border
        class="custom-padding-table" 
        show-summary
        
      >
        <el-table-column
          prop="dateTime"
          label="系统日期"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="totalNewUserCount"
          label="当日总新增"
          align="center"
        ></el-table-column>
        <el-table-column
          prop="totalSystemPromotionCount"
          label="系统推广"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="totalOtherPromotionCount"
          label="他人推广"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="totalSelfRegisterCount"
          label="自主注册"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>
      <!--底部工具条-->
      <el-col :span="24" class="pageBar">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pages.pageIndex"
          :page-sizes="pages.pageArr"
          :page-size="pages.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pages.dataCount"
        >
        </el-pagination>
      </el-col>
    </div>
    <div v-if="activeName == 1">
      <!--顶部工具条-->
      <el-col :span="24">
        <el-form :inline="true">
          <el-form-item label="">
            <el-input
              style="width: 170px"
              v-model.trim="filters2.keyWord"
              placeholder="请输入姓名~手机号"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item label="省份:">
            <el-select
              style="width: 100px"
              clearable
              v-model="filters2.provinceId"
              placeholder="请选择"
              @change="handleProvinceChange"
            >
              <el-option
                v-for="item in provinceOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="城市:">
            <el-select
              style="width: 100px"
              v-model="filters2.cityId"
              placeholder="请选择"
              clearable
            >
              <el-option
                v-for="item in cityOptions"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input
              v-model="filters2.startAmount"
              placeholder="请输入金额"
              style="width: 120px"
              clearable
            >
            </el-input
            >——
            <el-input
              v-model="filters2.endAmount"
              placeholder="请输入金额"
              style="width: 120px"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              style="width: 120px"
              v-model="filters2.userSource"
              placeholder="请选择来源"
              clearable
            >
              <el-option
                v-for="item in userSourceOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input
              style="width: 140px"
              v-model="filters2.inviteUserName"
              placeholder="请输入推广人"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-select
              style="width: 120px"
              v-model="filters2.userType"
              placeholder="用户身份"
              clearable
            >
              <el-option
                v-for="item in userTypeOptions"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="handleSearch2">查询</el-button>
            <el-button type="primary" @click="exportMessageExcel">导出</el-button>
          </el-form-item>
        </el-form>
      </el-col>
      <!--列表-->
      <el-table
        :data="tableData2"
        highlight-current-row
        v-loading="listLoading"
        style="width: 100%"
        border
         class="custom-padding-table" 
      >
        <!-- <el-table-column
          prop="id"
          label="账号"
          align="center"
          show-overflow-tooltip
        ></el-table-column> -->
        <el-table-column prop="nickName" label="用户名（昵称）" align="center">
         
        </el-table-column>
        <el-table-column
          prop="phoneNumber"
          label="手机"
          align="center"
          show-overflow-tooltip
         min-width="120" 
        
        ></el-table-column>
        <el-table-column
          prop="status"
          label="账号状态"
          align="center"
          show-overflow-tooltip
        >
          <template #default="scope">
            <el-tag v-if="scope.row.status == 1" type="success">正常</el-tag>
            <el-tag v-if="scope.row.status == 2" type="warning">禁用</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="totalAmount"
          label="消费（元）"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="totalIncomeAmount"
          label="收入（元）"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="totalMedal"
          label="勋章数量"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="provinceName"
          label="省份"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="cityName"
          label="城市"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="gender"
          label="性别"
          align="center"
          show-overflow-tooltip
        >
          <template #default="scope">
            <el-tag type="info" v-if="scope.row.gender == 0">未知</el-tag>
            <el-tag  v-if="scope.row.gender == 1">男</el-tag>
            <el-tag type="success" v-if="scope.row.gender == 2">女</el-tag>
          </template>
        </el-table-column>
        <el-table-column
          prop="age"
          label="年龄段"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="occupation"
          label="职业身份"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
        <el-table-column
          prop="userSource"
          label="来源类型"
          align="center"
          show-overflow-tooltip
        >
          <template #default="scope">
            <span v-if="scope.row.userSource == 1">自主注册</span>
            <span v-if="scope.row.userSource == 2">他人推广</span>
            <span v-if="scope.row.userSource == 3">系统推广</span>
            <span v-if="scope.row.userSource == 4">其他</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="createTime"
          label="注册时间"
          align="center"
          show-overflow-tooltip
          width="180"
        ></el-table-column>
        <el-table-column
          prop="lastLoginTime"
          label="最新登录时间"
          align="center"
          show-overflow-tooltip
            width="180"
        ></el-table-column>
        <el-table-column fixed="right" label="操作" width="" align="center">
        <template slot-scope="scope">
          <el-button
            type="text"
            size="small"
            @click="goToDetail(scope.row)"
            >查看明细</el-button
          >
        </template>
      </el-table-column>
      </el-table>

      <!--底部工具条-->
      <el-col :span="24" class="pageBar">
        <el-pagination
          @size-change="handleSizeChange2"
          @current-change="handleCurrentChange2"
          :current-page="pages2.pageIndex"
          :page-sizes="pages2.pageArr"
          :page-size="pages2.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="pages2.dataCount"
        >
        </el-pagination>
      </el-col>
    </div>
  </div>
</template>

<script>
import util from "../../../util/date";
import {
  getUserQmxfDataListPageCount,
  getUserProfile,
  getAreaDictionaryList,
  exportUserProfileApi,
  exportUserQmxfDataListPageCountApi,
  getUserQmxfDataListPageCountAll

} from "../../api/api";
import { getButtonList } from "../../promissionRouter";
import Toolbar from "../../components/Toolbar";

export default {
  components: { Toolbar },
  data() {
    return {
      util: "",
      activeName: "0",
      tableData: [],
      tableData2: [],
      listLoading: false,
      //增删改查按钮
      buttonList: [],
      //顶部筛选条件
      filters: {
        serachTimer: "",
        startAmount: "",
        endAmount: "",
      },
      //顶部筛选条件
      filters2: {
        keyWord: "",
        provinceId: "",
        cityId: "",
        startAmount: "",
        endAmount: "",
        inviteUserName: "",
        userType: "",
        userSource: "",
      },
      //关于分页的obj
      pages: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
      //关于分页的obj
      pages2: {
        pageSize: 20, //默认每页条数
        pageArr: [10, 20, 30, 40], //默认每页条数选择
        pageIndex: 1, //默认进入页
        dataCount: 20, //默认总页数
      },
      provinceOptions: [],
      cityOptions: [],
      // 用户来源
      userSourceOptions: [
        {
          value: "1",
          label: "自主注册",
        },
        {
          value: "2",
          label: "他人推广",
        },
        {
          value: "3",
          label: "系统推广",
        },
        {
          value: "4",
          label: "其他",
        },
      ],
      // 用户类型
      userTypeOptions: [
        {
          value: "1",
          label: "小程序普通用户",
        },
        {
          value: "2",
          label: "大V",
        },
        {
          value: "3",
          label: "清大员工",
        },
      ],
      pid: 0,
      allCount:""
    };
  },
  methods: {
    handleSearch() {
      this.pages.pageIndex = 1;
      this.getList();
    },
    handleSearch2() {
      this.pages2.pageIndex = 1;
      this.getUserProfileList();
    },
    // 当省份改变时重新获取城市
    handleProvinceChange(val) {
      this.filters2.cityId = "";
      this.pid = val;
      this.getProvinceCityInfo(1);
    },
    // 获取省市接口
    getProvinceCityInfo(type) {
      var params = {
        pid: this.pid,
      };
      getAreaDictionaryList(params).then((res) => {
        if (type == 0) {
          this.provinceOptions = res.data.response;
        } else if (type == 1) {
          this.cityOptions = res.data.response;
        }
      });
    },
    goToDetail(row) {
      this.$router.push({
        path: "/userDetails",
        query: { id: row.id },
      });
    },
    handleClick(e) {
      this.activeName = e.index;
      if (this.activeName == 0) {
        this.getList();
      }
      if (this.activeName == 1) {
        this.getUserProfileList();
      }
    },
    formatCreateTime: function (date) {
      return !date || date == ""
        ? ""
        : util.formatDate.format(new Date(date), "yyyy-MM-dd");
    },
    exportExcel() {},
    // 重置查询条件
    ResetQuery() {
      (this.filters = {
        serachTimer: "",
        startAmount: "",
        endAmount: "",
      }),
        (this.pages.pageIndex = 1);
      this.pages.pageSize = 20;
      this.getList();
    },
    //获取用户明细列表
    getUserProfileList() {
      this.listLoading = true;
      var params = {
        ...this.filters2,
        pageIndex: this.pages2.pageIndex,
        pageSize: this.pages2.pageSize,
      };
      getUserProfile(params).then((res) => {
        this.tableData2 = res.data.response.data;
        this.listLoading = false;
        this.pages2.dataCount = res.data.response.dataCount;
      });
    },

    //获取用户统计列表
    getList() {
      this.listLoading = true;
      var params = {
        startAmount: this.filters.startAmount,
        endAmount: this.filters.endAmount,
        pageIndex: this.pages.pageIndex,
        pageSize: this.pages.pageSize,
        startTime: this.filters.serachTimer
          ? this.formatCreateTime(this.filters.serachTimer[0])
          : "",
        endTime: this.filters.serachTimer
          ? this.formatCreateTime(this.filters.serachTimer[1])
          : "",
      };
      getUserQmxfDataListPageCount(params).then((res) => {
        this.tableData = res.data.response.data;
        this.listLoading = false;
        this.pages.dataCount = res.data.response.pageCount;
      });
    },
    getUserQmxfDataListPageCountAll(){
      getUserQmxfDataListPageCountAll().then((res) => {
        if(res.data.success){
          this.allCount =  res.data.response 
        }
         
      });
    },

    // apply改变this指向
    callFunction(item) {
      this[item.func].apply(this, item);
    },
    // 分页
    handleCurrentChange(val) {
      this.pages.pageIndex = val;
      this.getList();
    },
    handleSizeChange(val) {
      this.pages.pageSize = val;
      this.getList();
    },
    // 分页
    handleCurrentChange2(val) {
      this.pages2.pageIndex = val;
      this.getUserProfileList();
    },
    handleSizeChange2(val) {
      this.pages2.pageSize = val;
      this.getUserProfileList();
    },
     exportExcel() {
      this.listLoading = true;
      let params = {
         startAmount: this.filters.startAmount,
        endAmount: this.filters.endAmount,
        startTime: this.filters.serachTimer
          ? this.formatCreateTime(this.filters.serachTimer[0])
          : "",
        endTime: this.filters.serachTimer
          ? this.formatCreateTime(this.filters.serachTimer[1])
          : "",
      };
     exportUserQmxfDataListPageCountApi(
            params,
        )
        .then((res) => {
          this.listLoading = false;

          // 2. 检查是否有数据
          if (!res.data || res.data.size === 0) {
            this.$message.error("导出失败：服务器返回数据为空");
            return;
          }

          // 3. 【核心】创建 Blob 对象
          // 明确指定 MIME 类型，这有助于浏览器识别文件
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          // 4. 创建下载链接
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          // --- 🔥 替换开始：文件名解析逻辑优化 🔥 ---
          let fileName = "产品区域推广订单用户明细.xlsx"; // 默认文件名
          console.log('res',res)
          const disposition = res.headers["content-disposition"];
          console.log('disposition',disposition)

          if (disposition) {
            // 1. 优先处理 RFC 5987 标准格式: filename*=UTF-8''xxxxx
            // 这种格式专门用于解决中文文件名乱码问题
            console.log('走这里了')
            const utf8Match = disposition.match(/filename\*=UTF-8''(.+)/i);
            console.log('utf8Match',utf8Match)
            if (utf8Match && utf8Match[1]) {
              try {
                // 直接解码 URL 编码的字符串
                fileName = decodeURIComponent(utf8Match[1]);
                console.log("✅ 解析到的文件名 (UTF-8*):", fileName);
              } catch (e) {
                console.error("❌ 文件名解码失败:", e);
                fileName = "产品区域推广订单用户明细.xlsx";
              }
            } else {
               console.log('走这里了222')
              // 2. 备用：处理普通格式 filename="xxxxx" 或 filename=xxxxx
              const normalMatch = disposition.match(/filename="?([^";\n]*)"?/i);
              console.log('normalMatch',normalMatch[1])
              if (normalMatch && normalMatch[1]) {
                let tempName = normalMatch[1];
                // 尝试解码（防止后端虽然没写 UTF-8* 但实际发了编码后的字符串）
                try {
                  if (tempName.includes("%")) {
                    fileName = decodeURIComponent(tempName);
                  } else {
                    fileName = tempName;
                  }
                } catch (e) {
                  fileName = tempName;
                }
              }
            }
          }

          // 确保后缀名正确
          if (!fileName.endsWith(".xlsx")) {
            fileName += ".xlsx";
          }
          // --- 🔥 替换结束 🔥 ---

          link.download = fileName;

          // 6. 触发下载
          document.body.appendChild(link);
          link.click();

          // 7. 清理内存
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);

          this.$message.success("导出成功");
        })
        .catch((err) => {
          this.listLoading = false;
          console.error("导出异常:", err);

          // 错误处理：尝试读取错误信息
          if (err.response && err.response.data) {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const json = JSON.parse(reader.result);
                this.$message.error(json.message || "导出失败");
              } catch (e) {
                this.$message.error("导出失败：服务器返回非预期数据");
              }
            };
            reader.readAsText(err.response.data);
          } else {
            this.$message.error("网络错误，导出失败");
          }
        });
    },

     exportMessageExcel() {
      this.listLoading = true;
      const params = {
        ...this.filters2
      };
     exportUserProfileApi(
            params,
        )
        .then((res) => {
          this.listLoading = false;

          // 2. 检查是否有数据
          if (!res.data || res.data.size === 0) {
            this.$message.error("导出失败：服务器返回数据为空");
            return;
          }

          // 3. 【核心】创建 Blob 对象
          // 明确指定 MIME 类型，这有助于浏览器识别文件
          const blob = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          });

          // 4. 创建下载链接
          const link = document.createElement("a");
          link.href = window.URL.createObjectURL(blob);
          // --- 🔥 替换开始：文件名解析逻辑优化 🔥 ---
          let fileName = "产品区域推广订单用户明细.xlsx"; // 默认文件名
          console.log('res',res)
          const disposition = res.headers["content-disposition"];
          console.log('disposition',disposition)

          if (disposition) {
            // 1. 优先处理 RFC 5987 标准格式: filename*=UTF-8''xxxxx
            // 这种格式专门用于解决中文文件名乱码问题
            console.log('走这里了')
            const utf8Match = disposition.match(/filename\*=UTF-8''(.+)/i);
            console.log('utf8Match',utf8Match)
            if (utf8Match && utf8Match[1]) {
              try {
                // 直接解码 URL 编码的字符串
                fileName = decodeURIComponent(utf8Match[1]);
                console.log("✅ 解析到的文件名 (UTF-8*):", fileName);
              } catch (e) {
                console.error("❌ 文件名解码失败:", e);
                fileName = "产品区域推广订单用户明细.xlsx";
              }
            } else {
               console.log('走这里了222')
              // 2. 备用：处理普通格式 filename="xxxxx" 或 filename=xxxxx
              const normalMatch = disposition.match(/filename="?([^";\n]*)"?/i);
              console.log('normalMatch',normalMatch[1])
              if (normalMatch && normalMatch[1]) {
                let tempName = normalMatch[1];
                // 尝试解码（防止后端虽然没写 UTF-8* 但实际发了编码后的字符串）
                try {
                  if (tempName.includes("%")) {
                    fileName = decodeURIComponent(tempName);
                  } else {
                    fileName = tempName;
                  }
                } catch (e) {
                  fileName = tempName;
                }
              }
            }
          }

          // 确保后缀名正确
          if (!fileName.endsWith(".xlsx")) {
            fileName += ".xlsx";
          }
          // --- 🔥 替换结束 🔥 ---

          link.download = fileName;

          // 6. 触发下载
          document.body.appendChild(link);
          link.click();

          // 7. 清理内存
          document.body.removeChild(link);
          window.URL.revokeObjectURL(link.href);

          this.$message.success("导出成功");
        })
        .catch((err) => {
          this.listLoading = false;
          console.error("导出异常:", err);

          // 错误处理：尝试读取错误信息
          if (err.response && err.response.data) {
            const reader = new FileReader();
            reader.onload = () => {
              try {
                const json = JSON.parse(reader.result);
                this.$message.error(json.message || "导出失败");
              } catch (e) {
                this.$message.error("导出失败：服务器返回非预期数据");
              }
            };
            reader.readAsText(err.response.data);
          } else {
            this.$message.error("网络错误，导出失败");
          }
        });
    },
  },
  mounted() {
    this.getList();
    this.getUserQmxfDataListPageCountAll();
    this.getProvinceCityInfo(0);
    this.util = util;
    let routers = window.localStorage.router
      ? JSON.parse(window.localStorage.router)
      : [];
    this.buttonList = getButtonList(this.$route.path, routers);
  },
};
</script>
<style lang="stylus" scoped>
.rolesTop {
  width: 100%;
  display: flex;
}

.rolesInp {
  width: 300px;
  margin-right: 20px;
}

.pageBar {
  margin-top: 15px;
}

/* 👇👇👇 新增的样式开始 👇👇👇 */
.custom-padding-table
  ::v-deep .el-table__cell
    /* 上下内边距，根据需要调整数值，默认通常是 8px 或 10px */
    padding-top: 16px
    padding-bottom: 16px
    
  /* 如果上面的写法在某些构建环境下不生效，可以尝试加 !important 强制覆盖 */
  ::v-deep td.el-table__cell
    padding-top: 16px !important
    padding-bottom: 16px !important
/* 👆👆👆 新增的样式结束 👆👆👆 */
</style>
